import { HModules, HCF, HLink, HUtils } from "@macashipo/mlib"
const ModulePOS = {
  _key: "pos",
  _fnList: {},
  _config: {},
  getMyKey: () => {
    return "pos"
  },
  runAfterInit: HConfig => {
    // let _extraModules = process.env["REACT_APP_MODULES"]
    let _extraModules = "pos"
    if (_extraModules && _extraModules.split(",").indexOf("pos") > -1) {
      const MyUIOne = require("./MyUI/index").default
      console.log("MyUIOne:", MyUIOne)
      HModules.initDefault(ModulePOS, { MyUIOne })
    }
  },
}

export default ModulePOS
